import { useRef } from 'react';
import { useAdEventHandler } from '@archipro-website/tracker';
import { TopBanner } from '@rocco/ui/ad-top-banner/TopBanner';
import type { TopBannerAd } from '@modules/adverts/type';

interface AdvertTopBannerProps {
    ad: TopBannerAd;
}

/**
 * Tracking-aware wrapper for the site-wide top banner. Owns ad impression /
 * serve / click events and forwards the anchor ref into the presentational
 * Rocco {@link TopBanner}.
 */
export const AdvertTopBanner = ({ ad }: AdvertTopBannerProps) => {
    const ref = useRef<HTMLAnchorElement>(null);
    const { onClick: onAdClick } = useAdEventHandler(ad.advertCreative, ref);

    return (
        <TopBanner
            ref={ref}
            href={ad.href}
            alt={ad.title}
            imageDesktop={ad.imageDesktop}
            imageDesktop2x={ad.imageDesktop2x}
            imageMobile={ad.imageMobile}
            imageMobile2x={ad.imageMobile2x}
            onLinkClick={(event) => {
                event.preventDefault();
                onAdClick('Ad_ImageClick', ad.href);
            }}
        />
    );
};

export default AdvertTopBanner;
